import { ArticleHeading1, LinkButton } from '@cian/ui-kit';

import { Wrapper } from '../Wrapper';
import { content } from './content';
import { RealtorCard } from './components/RealtorCard';
import { applicationFormUrl, realtorsUrl } from '../../constants/urls';

import * as styles from './styles.css';

export interface IRealtorsProsp {
  onClickGoToAllRealtors(): void;
  onClickGoToApplicationForm(): void;
}

export const Realtors: React.FC<IRealtorsProsp> = ({ onClickGoToAllRealtors, onClickGoToApplicationForm }) => {
  /**
   * Первые 3 карточки рендерим в увеличенном формате (см. макет)
   * Остальные карточки обычного формата
   */
  const bigCards = content.slice(0, 3);
  const smallCards = content.slice(3);

  return (
    <div className={styles['container']}>
      <Wrapper>
        <div className={styles['title']}>
          <ArticleHeading1>Подбираем проверенных риелторов</ArticleHeading1>
        </div>
        <div className={styles['cards-big']}>
          {bigCards.map((item, index) => {
            return <RealtorCard key={index} isBig={true} {...item} />;
          })}
        </div>
        <div className={styles['cards']}>
          {smallCards.map((item, index) => {
            return <RealtorCard key={index} {...item} />;
          })}
        </div>
        <div className={styles['buttons']}>
          <LinkButton
            data-testid="Realtors_link"
            href={applicationFormUrl}
            onClick={onClickGoToApplicationForm}
            theme="fill_primary"
            size="L"
          >
            Подобрать риелтора
          </LinkButton>
          <LinkButton
            data-testid="Realtors_all_link"
            href={realtorsUrl}
            onClick={onClickGoToAllRealtors}
            theme="fill_secondary"
            size="L"
          >
            Посмотреть всех риелторов
          </LinkButton>
        </div>
      </Wrapper>
    </div>
  );
};

Realtors.displayName = 'Realtors';
